<template>
    <v-app>
        <div v-if="isDrawerEnabled">
            <v-navigation-drawer v-model="drawer" fixed app class="main-drawer">
                <v-list dense>
                    <v-subheader>Space Information</v-subheader>
                    <v-divider></v-divider>
                    <v-list-tile v-for="(value, key) in $store.state.spaceMetadata"
                                 v-bind:data="value"
                                 v-bind:key="key">
                        <v-list-tile-action>
                            {{key}}
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{value}}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-navigation-drawer>
        </div>

        <v-toolbar color="blue-grey darken-1" dark fixed prominent app class="dashboard-toolbar">
            <span v-if="isDrawerEnabled">
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            </span>
            <v-toolbar-title class="toolbar-title" v-if="$store.state.spaceMetadata" v-on:click="navigate('spaceDashboardContent')">
                <img :src="$store.state.spaceMetadata.icon" :alt="$store.state.spaceMetadata.name" class="space-icon">
                <span class="space-name">{{$store.state.spaceMetadata.name}}</span>
            </v-toolbar-title>
            <v-toolbar-items>
                <v-btn flat v-bind:to="{ name: 'spaceDashboardContent', params: { spaceIdentifier: spaceName }}"
                       class="toolbar-tab">
                    <span class="capitalize-text">
                        content
                    </span>
                </v-btn>
                <v-btn flat v-bind:to="{ name: 'spaceDashboardMedia', params: { spaceIdentifier: spaceName }}"
                       class="toolbar-tab">
                    <span class="capitalize-text">
                        media
                    </span>
                </v-btn>
                <v-menu offset-y>
                    <v-btn slot="activator" flat>
                        <font-awesome-icon :icon="['fal', 'cog']" class="toolbar-settings-icon"/>
                        <span class="settings-icon-spacer capitalize-text">Settings</span>
                        <font-awesome-icon :icon="['fal', 'chevron-down']"/>
                    </v-btn>
                    <v-list>
                        <v-list-tile v-for="setting in settingsDropdown" v-on:click="navigate(setting.routeName)">
                            <v-list-tile-title class="toolbar-settings-item">{{setting.displayName}}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-menu offset-y>
                    <v-btn slot="activator" flat>
                        <font-awesome-icon :icon="['fal', 'user']" class="toolbar-settings-icon"/>
                        <span class="icon-spacer"></span>
                        <font-awesome-icon :icon="['fal', 'chevron-down']"/>
                    </v-btn>
                    <v-list>
                        <v-list-tile>
                            <v-list-tile-title class="toolbar-settings-item">User Profile</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-on:click="logout">
                            <v-list-tile-title class="toolbar-settings-item">Logout</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <router-view></router-view>
    </v-app>
</template>

<script>
    import {
        LOAD_SPACE_METADATA,
        PURGE_SPACE_STATE_FOR_LOGOUT
    } from "../services/constants"

    export default {
        name: 'space-dashboard',
        data: function () {
            return {
                drawer: false,
                spaceName: this.$route.params.spaceIdentifier,
                settingsDropdown: [
                    {
                        displayName: 'API keys',
                        routeName: 'settingsAPIKeys'
                    },
                    {
                        displayName: 'Users',
                        routeName: 'settingsUsers'
                    },
                ]
            }
        },
        computed: {
            isDrawerEnabled() {
                return false
            }
        },
        methods: {
            logout: function () {
                this.$store.dispatch(PURGE_SPACE_STATE_FOR_LOGOUT)
                this.$router.push({name: 'login', params: {spaceIdentifier: this.spaceName}})
            },
            navigate: function (routeName) {
                this.$router.push({name: routeName})
            }
        },
        created: function () {
            if (!this.$store.state.spaceMetadata) {
                return this.$store.dispatch(LOAD_SPACE_METADATA, {
                    spaceIdentifier: this.$route.params.spaceIdentifier
                })
            }
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .dashboard-toolbar {
        z-index: 4;
    }

    .main-drawer {
        z-index: 5;
    }

    .toolbar-title {
        margin: 0 2em 0 0;
        cursor: pointer;
        img.space-icon {
            $img-size: 64px;
            max-height: $img-size;
            max-width: $img-size;
            vertical-align: middle;
        }
    }

    .space-name {
        margin: 0 0 0 1em;
    }

    .icon-spacer {
        width: 0.5em;
    }

    .toolbar-settings-icon {
        font-size: 1.5em;
    }

    .toolbar-settings-item {
        font-size: 14px;
    }

    .toolbar-tab {
        min-width: 10em;
        &.btn--active {
            border-bottom: white solid 3px;
        }
    }

</style>
